import { render, staticRenderFns } from "./bad_debt.vue?vue&type=template&id=38c11f4c&"
import script from "./bad_debt.vue?vue&type=script&lang=js&"
export * from "./bad_debt.vue?vue&type=script&lang=js&"
import style0 from "./bad_debt.vue?vue&type=style&index=0&id=38c11f4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports